/* GU Sticky ATC — DL Media. Proxies the main Dawn product form; see sections/gu-sticky-atc.liquid */
if (!customElements.get('gu-sticky-atc')) {
  customElements.define('gu-sticky-atc', class extends HTMLElement {
    connectedCallback() {
      this.info = document.querySelector('product-info[data-section*="__main"]') || document.querySelector('product-info');
      if (!this.info) return;
      this.btn = this.querySelector('[data-satc-btn]');
      this.label = this.querySelector('[data-satc-label]');
      this.priceEl = this.querySelector('[data-satc-price]');
      this.fields = [...this.querySelectorAll('[data-satc-field]')];

      this.btn.addEventListener('click', () => this.onClick());
      this.fields.forEach((field) => {
        field.querySelector('[data-satc-trigger]').addEventListener('click', () => {
          this.openField === field ? this.close() : this.open(field);
        });
        field.querySelector('[data-satc-close]').addEventListener('click', () => this.close(true));
        field.querySelector('[data-satc-choices]').addEventListener('click', (e) => {
          const chip = e.target.closest('[data-value]');
          if (!chip) return;
          this.setMain(field.dataset.satcField, chip.dataset.value);
          this.close(true);
        });
      });

      this.onDocDown = (e) => { if (this.openField && !this.contains(e.target)) this.close(); };
      this.onKey = (e) => { if (e.key === 'Escape' && this.openField) this.close(true); };
      document.addEventListener('pointerdown', this.onDocDown);
      document.addEventListener('keydown', this.onKey);

      this.observeVisibility();
      // Dawn re-renders price/button/pickers via innerHTML on variant change — resync on any mutation.
      this.mo = new MutationObserver(() => { clearTimeout(this.t); this.t = setTimeout(() => this.sync(), 60); });
      this.mo.observe(this.info, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled', 'checked', 'class'] });
      this.info.addEventListener('change', () => setTimeout(() => this.sync(), 60));
      this.sync();
    }

    disconnectedCallback() {
      this.mo && this.mo.disconnect();
      this.io && this.io.disconnect();
      document.removeEventListener('pointerdown', this.onDocDown);
      document.removeEventListener('keydown', this.onKey);
    }

    get mainBtn() { return this.info.querySelector('[id^="ProductSubmitButton"]'); }
    get pickers() { return this.info.querySelector('variant-selects, variant-radios'); }

    observeVisibility() {
      const btn = this.mainBtn;
      const target = btn;
      if (!target || target === this.observed) return;
      if (!this.io) {
        // Show whenever the main ATC isn't meaningfully on screen — above OR below the fold,
        // or tucked behind the sticky header.
        const hdr = document.querySelector('sticky-header, .section-header, header');
        const hh = hdr ? Math.round(hdr.getBoundingClientRect().height) : 0;
        this.io = new IntersectionObserver(([e]) => {
          this.toggle(e.intersectionRatio < 0.6);
        }, { rootMargin: '-' + hh + 'px 0px 0px 0px', threshold: [0, 0.3, 0.6, 1] });
      }
      if (this.observed) this.io.unobserve(this.observed);
      this.io.observe(target);
      this.observed = target;
    }

    toggle(show) {
      if (!show) this.close();
      this.classList.toggle('is-visible', show);
      this.setAttribute('aria-hidden', show ? 'false' : 'true');
      document.body.classList.toggle('gu-satc-open', show);
    }

    open(field) {
      this.close();
      this.renderChoices(field);
      const panel = field.querySelector('[data-satc-panel]');
      panel.hidden = false;
      field.querySelector('[data-satc-trigger]').setAttribute('aria-expanded', 'true');
      this.classList.add('has-panel');
      this.openField = field;
      const cur = panel.querySelector('[aria-pressed="true"]') || panel.querySelector('[data-value]');
      cur && cur.focus({ preventScroll: true });
    }

    close(refocus) {
      const field = this.openField;
      if (!field) return;
      field.querySelector('[data-satc-panel]').hidden = true;
      const trig = field.querySelector('[data-satc-trigger]');
      trig.setAttribute('aria-expanded', 'false');
      this.classList.remove('has-panel');
      this.openField = null;
      if (refocus) trig.focus({ preventScroll: true });
    }

    // Find the main picker for an option by NAME, not position — GU PDP renders Color
    // before Size even where Size is option1.
    fieldsetFor(name) {
      const p = this.pickers;
      if (!p || !name) return null;
      return [...p.querySelectorAll('fieldset, .product-form__input--dropdown')].find((fs) => {
        const inp = fs.querySelector('input[type="radio"], select');
        const nm = ((inp && inp.name) || '').trim().toLowerCase()
          .replace(/^options\[|\]$/g, '').replace(/-\d+$/, '');
        const lg = ((fs.querySelector('legend, label') || {}).textContent || '').trim().toLowerCase();
        return nm === name || lg.startsWith(name);
      }) || null;
    }

    // One entry per value of the main picker: value, short label, swatch node, availability, checked.
    choicesFor(fs) {
      const radios = [...fs.querySelectorAll('input[type="radio"]')];
      if (radios.length) {
        return radios.map((r) => {
          const lab = fs.querySelector(`label[for="${CSS.escape(r.id)}"]`);
          let text = '';
          if (lab) {
            text = [...lab.childNodes].filter((n) => n.nodeType === 3).map((n) => n.textContent).join('').trim();
          }
          return {
            value: r.value,
            text: text || r.value,
            swatch: lab && lab.querySelector('.swatch'),
            out: r.classList.contains('disabled') || r.disabled || r.dataset.optionAvailable === 'false',
            checked: r.checked,
          };
        });
      }
      const s = fs.querySelector('select');
      if (!s) return [];
      return [...s.options].map((o) => ({
        value: o.value,
        text: o.textContent.replace(/\s*-\s*(Sold out|Unavailable).*$/i, '').trim(),
        swatch: null,
        out: o.disabled || o.classList.contains('disabled') || /sold out|unavailable/i.test(o.textContent),
        checked: o.selected,
      }));
    }

    cloneSwatch(sw) {
      const c = sw.cloneNode(true);
      c.removeAttribute('id');
      c.classList.add('gu-satc__sw');
      return c;
    }

    renderChoices(field) {
      const fs = this.fieldsetFor(field.dataset.satcField);
      const box = field.querySelector('[data-satc-choices]');
      if (!fs) { box.textContent = ''; return; }
      const isColor = field.hasAttribute('data-satc-color');
      const frag = document.createDocumentFragment();
      this.choicesFor(fs).forEach((ch) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'gu-satc__chip' + (ch.out ? ' is-out' : '');
        b.setAttribute('role', 'listitem');
        b.dataset.value = ch.value;
        b.setAttribute('aria-pressed', ch.checked ? 'true' : 'false');
        b.setAttribute('aria-label', ch.value + (ch.out ? ' — sold out' : ''));
        if (isColor) {
          const sw = document.createElement('span');
          sw.className = 'gu-satc__chip-swatch';
          if (ch.swatch) sw.appendChild(this.cloneSwatch(ch.swatch));
          b.appendChild(sw);
        }
        const t = document.createElement('span');
        t.className = 'gu-satc__chip-text';
        t.textContent = isColor ? ch.value : ch.text;
        b.appendChild(t);
        if (ch.out) {
          const o = document.createElement('span');
          o.className = 'gu-satc__chip-out';
          o.textContent = 'Sold out';
          b.appendChild(o);
        }
        frag.appendChild(b);
      });
      box.replaceChildren(frag);
    }

    setMain(name, value) {
      const fs = this.fieldsetFor(name);
      if (!fs) return;
      const radio = [...fs.querySelectorAll('input[type="radio"]')].find((r) => r.value === value);
      if (radio) {
        if (!radio.checked) { radio.checked = true; radio.dispatchEvent(new Event('change', { bubbles: true })); }
        return;
      }
      const sel = fs.querySelector('select');
      if (sel) {
        const opt = [...sel.options].find((o) => o.value === value);
        if (opt && sel.value !== opt.value) { sel.value = opt.value; sel.dispatchEvent(new Event('change', { bubbles: true })); }
      }
    }

    sync() {
      // Dawn can swap product-info wholesale (combined listings) — re-bind if so.
      if (!this.info.isConnected) {
        this.mo.disconnect();
        this.info = document.querySelector('product-info[data-section*="__main"]') || document.querySelector('product-info');
        if (!this.info) return;
        this.mo.observe(this.info, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled', 'checked', 'class'] });
      }
      this.observeVisibility();
      const main = this.mainBtn;
      if (main) {
        this.btn.disabled = main.disabled || main.hasAttribute('disabled');
        const txt = (main.querySelector('span') || main).textContent.trim();
        if (txt) this.label.textContent = txt;
      }
      const box = this.info.querySelector('[id^="price-"] .price');
      const p = box && (box.classList.contains('price--on-sale')
        ? box.querySelector('.price__sale .price-item--sale')
        : box.querySelector('.price__regular .price-item--regular'));
      if (p && this.priceEl) this.priceEl.textContent = p.textContent.trim();

      this.fields.forEach((field) => {
        const fs = this.fieldsetFor(field.dataset.satcField);
        if (!fs) { field.hidden = true; return; }
        field.hidden = false;
        const cur = this.choicesFor(fs).find((c) => c.checked);
        const valEl = field.querySelector('[data-satc-value]');
        if (cur && valEl) valEl.textContent = field.hasAttribute('data-satc-color') ? cur.value : cur.text;
        const swEl = field.querySelector('[data-satc-swatch]');
        if (swEl) swEl.replaceChildren(...(cur && cur.swatch ? [this.cloneSwatch(cur.swatch)] : []));
        if (this.openField === field) this.renderChoices(field);
      });
    }

    onClick() {
      const main = this.mainBtn;
      if (!main || main.disabled) {
        (this.pickers || this.info).scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      main.click();
    }
  });
}
